// extracted by mini-css-extract-plugin
module.exports = {"base":"Footer_base__2-TB4","main":"Footer_main__1fJma","logo":"Footer_logo__3b2YI","copyright":"Footer_copyright__2wqDr"};